import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from '@mui/material';
import { MdClose } from "@teamworksdev/icons";
import { useTranslation } from "react-i18next";

export const TabletExitWarning = ({
  open,
  setOpen,
  handleExitTabletMode,
}: {
  open: boolean;
  setOpen: (b: boolean) => void;
  handleExitTabletMode: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 1,
        }}
      >
        {t('exitTabletModeQuestion')}
        <IconButton onClick={() => setOpen(false)}>
          <MdClose />
        </IconButton>
      </DialogTitle>
      <DialogContent>{t('exitTabletModeDescription')}</DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined">
          {t('cancel')}
        </Button>
        <Button onClick={handleExitTabletMode}>{t('exit')}</Button>
      </DialogActions>
    </Dialog>
  );
};